export default {
  en: {
    'bundles-registrations.registrations-de-register-drawer.title': 'De-Register Registration',
    'bundles-registrations.registrations-de-register-drawer.confirmClose.continue':
      'Continue editing',
    'bundles-registrations.registrations-de-register-drawer.confirmClose.discard':
      'Discard changes',
    'bundles-registrations.registrations-de-register-drawer.confirmClose.unsaved-changes':
      'You have unsaved changes. Are you sure you want to continue?',
  },
};
